import { Input } from '../../../../components/inputs';
import { EditorProps } from '../types/editor-props';

/**
 * Simple text input editor for EditableField.
 * Renders an <Input> with the current value, and calls onChange/onBlur as needed.
 * Designed to be used as the default editor for string fields in the FieldEditor component,
 * but can also be used standalone when a basic text input is sufficient.
 */
export function TextEditor({ id, value, onChange, onBlur }: EditorProps) {
  return (
    <Input
      id={id}
      value={value == null ? '' : String(value)}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      autoFocus
      className='h-8 text-sm'
    />
  );
}
